<div [formGroup]="assetItemForm">
  <div class="thumbnail" [class.active]="isLoading"
    [matTooltip]="assetItemForm.get('name').value" matTooltipPosition="below"
    #assetThumbnail (clickOutside)="unsetClass('image')" (click)="setClass($event)">
    <div *ngIf="isLoading; else elseBlock" class="active thumbnail-upload-progress">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <ng-template #elseBlock>
      <div [ngClass]="{ 'thumbnail-action': thumbnailIsClicked }">
        <div class="controls" (click)="$event.stopPropagation()">
          <ng-container *ngIf="!assetItemForm.get('downloading')?.value else whenDownLoading">
              <a class="control-btn" *ngIf="!!this.assetItemForm.get('showOpenInNew')?.value" ><i class="material-icons" (click)="openInNew(assetItemForm)">open_in_new</i></a>
              <a class="control-btn move" *ngIf="!this.assetItemForm.get('showOpenInNew')?.value"><i class="material-icons" (click)="showFullSize(assetItemForm)">open_with</i></a>
              <a class="control-btn readonly-disabled" *ngIf="!hideReportDefaultIcons">
                <i class="material-icons" [ngClass]="{ 'thumbnail-selected': assetItemForm.get('defaultC').value }" (click)="setDefaultItem(assetItemForm)">star</i>
              </a>
              <a class="control-btn">
                <i class="material-icons" (click)="downloadItem(assetItemForm, $event)">file_download</i>
              </a>
              <a class="control-btn remove readonly-disabled" [ngClass]="{'disabled-anchor' : preventRemoval  }">
                <i class="material-icons" (click)="$event.stopPropagation(); !preventRemoval && removeItem(current)" [ngClass]="{'disabled' : preventRemoval  }">delete</i>
              </a>    
          </ng-container>
        </div>
        <ng-template #whenDownLoading>
            <spinner-small [isRunning]="assetItemForm.get('downloading')?.value" ></spinner-small>
        </ng-template>
        <div *ngIf="IsActualImage===true; else imageElseBlock;" [ngClass]="{ 'photo-stack': !thumbnailIsClicked }">
          <img crossOrigin="Anonymous" id="{{ 'id' + current }}"
          [ngClass]="{ 'thumbnail-loading': assetItemForm.get('loading')?.value, 'selected': assetItemForm.get('defaultC')?.value && assetItemForm.get('assetType')?.value == 'Image'}"
          [ngStyle]="ciImageStyle" (error)="setDefaultPic()" class="hoverable">
          
          <img *ngFor="let rimage of this.assetItemForm.get('relatedImages').value.slice(0,3)" [src]="rimage.thumbnailFullUrl" [ngStyle]="{ 'display': thumbnailIsClicked ? 'none' : 'block' }" />
        </div>


      </div>
      <ng-template #imageElseBlock>
        <div [ngClass]="{ 'photo-stack': !thumbnailIsClicked }">
          <i class="material-icons watermark" [ngStyle]="ciImageStyle">attach_file</i>
          <i [ngStyle]="{ 'display': thumbnailIsClicked ? 'none' : 'block' }" *ngFor="let rimage of this.assetItemForm.get('relatedImages').value.slice(0,3)" class="material-icons watermark" [ngStyle]="ciImageStyle">attach_file</i>
        </div>
      </ng-template>
    </ng-template>
  </div>
  <p class="img-title">{{ assetItemForm.get('name').value }}</p>
</div>
<!-- assetItemForm: {{ assetItemForm.value | json}} -->
